export default "__VITE_ASSET__4xsr6C2r__"